import { push } from 'react-router-redux';
import firebase from 'firebase/app';
import actions from '../constants';

export default (id) => (dispatch) => {
  return firebase.database().ref('organizations').child(id).child('details').once('value')
    .then(snapshot => {
      const orgDetails = snapshot.val();

      dispatch({
        type: actions.SELECT_FINISH,
        payload: {
          id,
          ...orgDetails
        },
      });

      dispatch(push('/'));
    },
    error => dispatch({
      type: actions.SELECT_ERROR,
      error: error,
    }));
};



// WEBPACK FOOTER //
// ./src/modules/organizations/actions/selectOrganization.js